import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {RoutingConstants} from '../../../../models/routing/routing-constants';
import { MessageModule } from 'primeng/message';
import { Button } from 'primeng/button';

@Component({
    selector: 'app-unauth',
    templateUrl: 'unauth-view.component.html',
    imports: [MessageModule, Button]
})
export class UnauthViewComponent {

    constructor(private router: Router) {
    }


    goToHome() {
        this.router.navigateByUrl(RoutingConstants.dashboard);
    }
}
